<template>
  <div class="wrapper">
    <!-- header -->
    <header class="header">
      <div class="header-inner container">
        <div class="left">
          <img
            src="@/assets/img/conf2024/header/logo.png"
            alt="logo"
            class="logo"
          />
        </div>
      </div>
    </header>

    <!-- content -->
    <section class="content">
      <!-- main -->
      <article class="main">
        <div class="main-inner container">
          <img
            src="@/assets/img/conf2024/complete/text0.png"
            alt="the 18th 글로벌 역량강화"
            class="text0"
          />
          <img
            src="@/assets/img/conf2024/complete/text1.png"
            alt="hrd conference"
            class="text1"
          />
          <img
            src="@/assets/img/conf2024/complete/text2.png"
            alt="2024"
            class="text2"
          />
        </div>
      </article>

      <!-- fiy -->
      <article class="fiy">
        <div class="fiy-inner container">
          <p>신청이 성공적으로 완료되었습니다.</p>
          <p>
            “제18회 글로벌 역량강화 컨퍼런스 2024” 신청이 성공적으로
            완료되었습니다.
          </p>
          <p>
            글로벌 인재육성 전략에 특화된 컨퍼런스인<br />제 18회 글로벌
            역량강화 HRD 컨퍼런스 2024에서<br />다양한 정보 공유와 교류의 장을
            만나 보시기 바랍니다.<br /><br />좌석 확인 후 사전예약 확정 안내
            드릴 예정입니다.<br />
            감사합니다.
          </p>
          <div class="go-question" @click="goQuestion">
            <p>사전 질문 하러가기</p>
            <img
              src="@/assets/img/conf2024/question/arrow.png"
              alt="사전 질문 하러가기"
            />
          </div>
        </div>
      </article>

      <!-- question -->
      <article class="add">
        <div class="add-inner container">
          <p>오프라인 행사 일정 추가하기</p>
          <ul>
            <li>
              <a
                href="https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20230831T001500Z%2F20230831T004500Z"
                title="Save Event in my Calendar"
                target="_blank"
                >구글 캘린더 추가하기</a
              >
            </li>
            <li>
              <a
                href="https://outlook.office.com/calendar/action/compose?allday=false&enddt=2023-08-31T00%3A45%3A00%2B00%3A00&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-08-31T00%3A15%3A00%2B00%3A00&subject="
                title="Save Event in my Calendar"
                target="_blank"
                >아웃룩 캘린더 추가하기</a
              >
            </li>
          </ul>
        </div>
      </article>
    </section>

    <!-- footer -->
    <footer class="footer">
      <div class="footer-inner container">
        <img
          src="@/assets/img/conf2024/footer/logo.png"
          alt="2024 hrd conference"
        />
        <div>
          <p>(주)캐럿글로벌</p>
          <p>서울특별시 용산구 한남동 이태원로 268-20 | 02-518-5467</p>
          <p>© CARROT Global Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "complete",
  mounted() {
    // App.vue에 Menu 숨김
    // const header = document.getElementById("header");
    // header.style.display = "none";
    // const footer = document.getElementById("footer");
    // footer.style.display = "none";
  },
  methods: {
    // 사전 질문 하러가기
    goQuestion() {
      location.href = "./question";
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css");

img {
  display: block;
  width: 100%;
}

textarea {
  resize: none;
  display: block;
  width: 100%;
  height: 100%;
}

.wrapper {
  position: relative;
  font-family: "Pretendard", "Malgun Gothic", "맑은고딕", sans-serif;
  // max-width: 1920px;
  // margin: 0 auto;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

// header
.header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  // max-width: 1920px;
  z-index: 1;
  background-color: rgba($color: #000, $alpha: 0.25);

  &.right-open {
    background-color: rgba($color: #292929, $alpha: 0.98);
  }

  .header-inner {
    @media screen and (min-width: 1000px) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      max-width: 158px;
    }
  }
}

// content

// main
.main {
  padding: 115px 0 74px;
  background: url(~@/assets/img/conf2024/question/bg-m.png) no-repeat center /
    cover;

  @media screen and (min-width: 1000px) {
    padding: 94px 0 65px;
    background: url(~@/assets/img/conf2024/question/bg-pc.png) no-repeat center /
      cover;
  }

  .main-inner {
    display: flex;
    flex-direction: column;
    align-items: center;

    .text0 {
      max-width: 240px;
      margin-bottom: 10px;

      @media screen and (min-width: 1000px) {
        max-width: 388px;
      }
    }

    .text1 {
      max-width: 297px;
      margin-bottom: 12px;

      @media screen and (min-width: 1000px) {
        max-width: 488px;
        margin-bottom: 18px;
      }
    }

    .text2 {
      max-width: 263px;

      @media screen and (min-width: 1000px) {
        max-width: 424px;
      }
    }
  }
}

// fiy
.fiy {
  .fiy-inner {
    padding: 62px 20px;

    @media screen and (min-width: 1000px) {
      padding: 135px 20px;
    }

    > p {
      text-align: center;

      &:nth-of-type(1) {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 35px;

        @media screen and (min-width: 1000px) {
          font-size: 50px;
          margin-bottom: 65px;
        }
      }

      &:nth-of-type(2) {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 25px;

        @media screen and (min-width: 1000px) {
          font-size: 24px;
          margin-bottom: 18px;
        }
      }

      &:nth-of-type(3) {
        line-height: 26px;
        margin-bottom: 48px;

        @media screen and (min-width: 1000px) {
          font-size: 20px;
          line-height: 30px;
          margin-bottom: 75px;
        }
      }
    }

    .go-question {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 11px;
      padding: 20px 43px;
      background-color: #13f194;
      border-radius: 59px;
      max-width: 324px;
      margin: 0 auto;
      cursor: pointer;

      @media screen and (min-width: 1000px) {
        gap: 15px;
        padding: 30px 80px;
        max-width: 403px;
      }

      p {
        font-size: 22px;
        font-weight: 700;
        color: #0d0d0d;

        @media screen and (min-width: 1000px) {
          font-size: 30px;
        }
      }

      img {
        max-width: 11px;
      }
    }
  }
}

// add
.add {
  padding: 20px 0;
  background: url(~@/assets/img/conf2024/complete/add-bg.png) no-repeat center /
    cover;

  @media screen and (min-width: 1000px) {
    padding: 46px 0;
  }

  .add-inner {
    p {
      font-size: 22px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      margin-bottom: 19px;

      @media screen and (min-width: 1000px) {
        font-size: 30px;
        text-align: left;
        margin-bottom: 30px;
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 20px;

      @media screen and (min-width: 1000px) {
        flex-direction: row;
        gap: 28px;
      }

      li {
        a {
          display: block;
          padding: 20px 60px;
          border-radius: 59px;
          width: 100%;
          max-width: 280px;
          margin: 0 auto;
          font-size: 18px;
          font-weight: 700;
          text-align: center;
        }

        &:nth-of-type(1) {
          a {
            color: #fff;
            background-color: #9945ff;
          }
        }

        &:nth-of-type(2) {
          a {
            color: #9945ff;
            border: 1px solid #9945ff;
          }
        }

        @media screen and (min-width: 1000px) {
          margin: 0;
        }
      }
    }
  }
}

// footer
.footer {
  padding: 20px 0;
  background-color: #000;

  @media screen and (min-width: 1000px) {
    padding: 39px 0 57px;
  }

  .footer-inner {
    display: flex;
    flex-direction: column;
    gap: 19px;

    @media screen and (min-width: 1000px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    img {
      max-width: 200px;

      @media screen and (min-width: 1000px) {
        max-width: 360px;
      }
    }

    > div {
      > p {
        font-size: 13px;
        color: #6c6c6c;
        line-height: 20px;

        @media screen and (min-width: 1000px) {
          font-size: 16px;
        }

        &:nth-of-type(1) {
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
